.confirm-modal__overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.confirm-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 90%;
  animation: slideUp 0.2s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.confirm-modal__header {
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px 12px 0 0;
}

.confirm-modal__header--danger {
  background: #fff5f5;
  border-bottom-color: #fecaca;
}

.confirm-modal__header--warning {
  background: #fffbeb;
  border-bottom-color: #fde68a;
}

.confirm-modal__header--info {
  background: #eff6ff;
  border-bottom-color: #bfdbfe;
}

.confirm-modal__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.confirm-modal__close {
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s;
}

.confirm-modal__close:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #666;
}

.confirm-modal__body {
  padding: 24px;
}

.confirm-modal__message {
  margin: 0;
  font-size: 15px;
  color: #666;
  line-height: 1.6;
}

.confirm-modal__footer {
  padding: 16px 24px;
  border-top: 1px solid #e9ecef;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.confirm-modal__btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.confirm-modal__btn--cancel {
  background: #f1f3f5;
  color: #666;
}

.confirm-modal__btn--cancel:hover {
  background: #e9ecef;
}

.confirm-modal__btn--confirm {
  color: white;
}

.confirm-modal__btn--danger {
  background: #dc3545;
}

.confirm-modal__btn--danger:hover {
  background: #c82333;
}

.confirm-modal__btn--warning {
  background: #ffc107;
  color: #333;
}

.confirm-modal__btn--warning:hover {
  background: #e0a800;
}

.confirm-modal__btn--info {
  background: #007bff;
}

.confirm-modal__btn--info:hover {
  background: #0056b3;
}

@media (max-width: 768px) {
  .confirm-modal {
    max-width: 95%;
  }

  .confirm-modal__header,
  .confirm-modal__body,
  .confirm-modal__footer {
    padding: 16px;
  }
}

.pf-delete-password {
  box-sizing: border-box;
  width: 100%;
  margin-top: 12px;
  padding: 12px;
  border: 1px solid #c9d3df;
  border-radius: 10px;
  font: inherit;
  font-size: 16px;
}
